<template>
    <div>
      <div id="poblationchart" class="poblation char" ref="poblationchart" :class="{'no-print2': yearRange}">
        <span class="sec-title">{{ $t('diagnostic.poblation.title') }}</span>
        <span class="sec-description">{{ $t('diagnostic.poblation.description') }}</span>
        <apexchart v-if="yearRange" class="canvas" :width="size" height="500" type="bar" :options="chartOptions" :series="yearRange"></apexchart>
        <div v-else class="no-data">{{ $t('diagnostic.poblation.no_data') }}</div>
      </div>
      <div id="poblationoptions" class="poblation options" ref="poblationoptions">
        <div class="env">
          <span class="sec-title">{{ $t('diagnostic.poblation.environment.title') }}</span>
          <span class="sec-description">{{ $t('diagnostic.poblation.environment.description') }}</span>
          <div class="box">
            <div v-for="item in enviroment" class="option" @click="selectOption(item)" :class="[{checked:item.restaurant_id != null && item.status==1}, item.name]">
              <img v-if="item.name=='Oficinas'" class="img delete" src="img/diagnostic/office.svg"/>
              <img v-else-if="item.name=='Universidad'" class="img delete" src="img/diagnostic/university.svg"/>
              <img v-else-if="item.name=='Colegios'" class="img delete" src="img/diagnostic/primary.svg"/>
              <img v-else-if="item.name=='Institutos'" class="img delete" src="img/diagnostic/secondary.svg"/>
              <img v-else-if="item.name=='Hospital'" class="img delete" src="img/diagnostic/hospital.svg"/>
              <img v-else-if="item.name=='Comercios'" class="img delete" src="img/diagnostic/commerce.svg"/>
              <img v-else-if="item.name=='Empresas'" class="img delete" src="img/diagnostic/business.svg"/>
              <img v-else-if="item.name=='Residencial'" class="img delete" src="img/diagnostic/residential.svg"/>
              <img v-else-if="item.name=='Residencial vacacional'" class="img delete" src="img/diagnostic/holiday.svg"/>
              <img v-else="item.name=='Oficinas'" class="img delete" src="img/diagnostic/other.svg"/>
              {{item.name}}
              <v-icon class="delete" v-if="item.custom" @click="deleteCustom(item)">delete</v-icon>
            </div>
            <span :contenteditable="contenteditable" ref="other" class="option other" @blur="resetOther($event)" @click="resetEnviroment()" v-on:keyup.enter="addEnviroment($event)">{{option}}</span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import i18n from '@/i18n';
export default {
  props: {size: String},
  data () {
    return {
        chartOptions: {
          chart: {
            stacked: true,
            toolbar: {
              show: false
            }
          },
          colors: ['#004412', '#FFBB0C'],
          plotOptions: {
            bar: {
              horizontal: true,
              barHeight: '80%',

            },
          },
          dataLabels: {
            enabled: true,
            formatter: function (val, opts) {
            return Math.abs(val)+"%"
          },
          },
          stroke: {
            width: 2,
            colors: ["#fff"]
          },

          grid: {
            xaxis: {
              showLines: false
            }
          },
          yaxis: {
            max: this.maxRestaurant,
            min: this.maxProvince,
            title: {
              offsetX:5,
            },
          },
          tooltip: {
            shared: false,
            x: {
              formatter: function (val) {
                return val + " años"
              }
            },
            y: {
              formatter: function (val) {
                return Math.abs(val) + "%"
              }
            }
          },
          xaxis: {
            categories: [this.$t('diagnostic.poblation.age.description'), this.$t('diagnostic.poblation.age.description_10_19'), this.$t('diagnostic.poblation.age.description_20_24'), this.$t('diagnostic.poblation.age.description_25_34'), this.$t('diagnostic.poblation.age.description_35_49'), this.$t('diagnostic.poblation.age.description_50_65'), this.$t('diagnostic.poblation.age.description_65_more')],
            title: {
              text: ' '
            },
            labels: {
              formatter: function (val) {
                return Math.abs(Math.round(val))+ "%"
              }
            }
          },
        },
        
        maxProvince: "",
        maxRestaurant: "",
        jsonprovince: "",
        jsonrestaurant: "",
        restaurant: "",

        contenteditable: false,
        option: this.$t('general.add_new'),
      }
  },
  computed: {
    province() {
      return this.$store.getters['locations/getProvince'];
    },

    enviroment() {
      return this.$store.getters['locations/getEnviroment'];
    },

    yearRange() {
      this.jsonrestaurant = JSON.parse(this.restaurant.habitants);
      if (this.jsonrestaurant != null) {
        return [{
            name: this.restaurant.name,
            data: [ -(this.jsonrestaurant.g1/this.jsonrestaurant.total*100).toFixed(2), -(this.jsonrestaurant.g2/this.jsonrestaurant.total*100).toFixed(2), -(this.jsonrestaurant.g3/this.jsonrestaurant.total*100).toFixed(2), -(this.jsonrestaurant.g4/this.jsonrestaurant.total*100).toFixed(2), -(this.jsonrestaurant.g5/this.jsonrestaurant.total*100).toFixed(2), -(this.jsonrestaurant.g6/this.jsonrestaurant.total*100).toFixed(2), -(this.jsonrestaurant.g7/this.jsonrestaurant.total*100).toFixed(2) ]
          },
          {
            name: this.province.name + " (provincia)",
            data: [ (this.jsonprovince.g1/this.jsonprovince.total*100).toFixed(2), (this.jsonprovince.g2/this.jsonprovince.total*100).toFixed(2), (this.jsonprovince.g3/this.jsonprovince.total*100).toFixed(2), (this.jsonprovince.g4/this.jsonprovince.total*100).toFixed(2), (this.jsonprovince.g5/this.jsonprovince.total*100).toFixed(2), (this.jsonprovince.g6/this.jsonprovince.total*100).toFixed(2), (this.jsonprovince.g7/this.jsonprovince.total*100).toFixed(2) ]
          }
        ];
      }
      else return false;
    },

    selectedLocation() {
      return this.restaurant = this.$store.getters['locations/getSelectedLocation'];
    },
    
  },
  methods: {
    resetEnviroment() {
      this.contenteditable = true;
      this.$nextTick(() => this.$refs.other.focus());
      this.option = "";
      event.target.innerText = "";
    },

    resetOther(event) {
      this.contenteditable = false;
      event.target.innerText = this.$t('general.add_new');
    },

    addEnviroment(event) {
      this.contenteditable = false;
      this.$overlay.loading();
      var self = this;
      this.$store.dispatch( 'locations/addEnviroment', {name: event.target.innerText, id: this.restaurant.id} ).then( function() {
        event.target.innerText = self.$t('general.add_new');
        self.$store.dispatch('locations/loadEnviroment', self.$store.getters['locations/getSelectedLocation'].id ).then(function(){
          self.$overlay.hide();
        });
      });
    },

    selectOption(item) {
      var self = this;
      this.$overlay.loading();
      if (item.restaurant_id==null) {
        this.$store.dispatch( 'locations/selectEnviroment', {id: item.id, restaurant_id: this.restaurant.id} ).then( function() {
        self.$store.dispatch('locations/loadEnviroment', self.$store.getters['locations/getSelectedLocation'].id ).then(function(){
          self.$overlay.hide();
        });
      });
      } else {
        this.$store.dispatch( 'locations/unselectEnviroment', {id: item.id, restaurant_id: this.restaurant.id} ).then( function() {
        self.$store.dispatch('locations/loadEnviroment', self.$store.getters['locations/getSelectedLocation'].id ).then(function(){
          self.$overlay.hide();
        });
      });
      }
    },

    deleteCustom(item) {
      var self = this;
      this.$popup.confirm( 
        this.$t('diagnostic.poblation.popup.title'), 
        this.$t('diagnostic.poblation.popup.description') + " <strong> " + item.name + " </strong> ?", 
        this.$t('general.delete'), 
        this.$t('general.cancel'),
        function(){
          self.$overlay.loading();
          self.$store.dispatch( 'locations/deleteEnviroment', {id: item.id} ).then( function() {
            self.$store.dispatch('locations/loadEnviroment', self.$store.getters['locations/getSelectedLocation'].id );
            self.$overlay.hide();
          });
        }
      );
    },

  },
  watch: {
    province () {
      if (this.province==undefined){
        this.$store.dispatch('locations/loadProvince', this.$store.getters['locations/getSelectedLocation'].id )
      }
      this.jsonprovince = JSON.parse(this.province.habitants);
      var max = -1;
      for (var item in this.jsonprovince){
        if (this.jsonprovince[item]>max && item!="total"){
          max = this.jsonprovince[item];
        }
      }
      this.maxProvince = (max/this.jsonprovince.total*100).toFixed(2);
     },

     selectedLocation () {
      if (this.selectedLocation==undefined){
        this.$store.getters['locations/getSelectedLocation'];
      }
      this.$store.dispatch('locations/loadProvince', this.$store.getters['locations/getSelectedLocation'].id );
      this.$store.dispatch('locations/loadEnviroment', this.$store.getters['locations/getSelectedLocation'].id );
     },
  },
  created() {
    this.$store.dispatch('locations/loadProvince', this.$store.getters['locations/getSelectedLocation'].id );
    this.$store.dispatch('locations/loadEnviroment', this.$store.getters['locations/getSelectedLocation'].id );
  },
  beforeRouteLeave (to, from, next) {
      next();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .sec-title {
    background: var(--main_color);
    color: var(--dark_color);
    display: inline-block;
    text-align: center;
    font-size: 19px;
    font-family: Speedee-Bold;
    margin: 15px 0;
    padding: 0px 10px;
    margin-bottom: 10px;
    z-index: 1;
  }

  .sec-description {
    display: block;
    color: #999;
    margin-bottom: 40px;
  }

  .poblation {
    margin-top: 20px;

    &.char{
      float: left;
      width: 100%;

      .canvas {
        margin-top: -30px;
        margin-bottom: 20px;
      }

      .no-data {
        width: 100%;
        background-color: #f3f3f3;
        padding: 50px;
        color: #999;
        font-size: 15px;
      }
    }

    &.options{
      float: right;
      width: 100%;

      .env {

        .box{
          width: 90%;
          margin: 0 auto;

          .option{
            display: inline-block;
            margin: 5px;
            padding: 6px 12px;
            border: #bbbb 2px solid;
            border-radius: 8px;
            cursor: pointer;

            .delete {
              margin-left: 5px;
              font-size: 17px;
            }

            .img {
              margin-right: 5px;
              position: relative;
              top: 2px;
              height: 17px;
              opacity: 0.5;
            }

            &:hover, &.checked {
              background-color: #cdeaac;
              border-color: #9bc766;
            }

            &:hover{
              font-weight: bold;
            }

            &.other{ 
              text-align: center;
              outline:0px;
            }            
          }
        }        
      }
    }
  }

</style>
